import _clone from 'lodash/clone';
import _isEmpty from 'lodash/isEmpty';
import _every from 'lodash/every';
import _extend from 'lodash/extend';
import _findIndex from 'lodash/findIndex';
import _isNumber from 'lodash/isNumber';
import _isBoolean from 'lodash/isBoolean';
import angular from 'angular';
import moment from 'moment';

import inventoryUtils from 'utils/inventoryUtils';

function AddInventoryCtrl($scope, $q, $timeout, venueService, inventoryService, sdkUtils, scheduleService, layoutSectionService,
  mapperService, dateUtilsService, alertService, formHelpersService, sellingOptionsHelpersService, colorService, supportService, modalService) { //eslint-disable-line
  if (!$scope.venue) throw new Error('venue is required');
  if (!$scope.inventory && !$scope.date) throw new Error('date is required');

  _getVenueAndInventory();
  _getLayoutSections();

  supportService.hide();

  $scope.inventory = $scope.inventory || null;
  $scope.editMode = !!$scope.inventory;
  $scope.date = moment.utc($scope.editMode ? $scope.inventory.date : $scope.date, 'x');
  $scope.schedule = $scope.schedule || false;
  $scope.closePanel = function ($event) {
    if ($event) $event.preventDefault();

    supportService.show();

    $timeout(() => {
      $scope.cancel();
    });
  };
  $scope.editMode = !!$scope.inventory;

  $scope.venueBrandColors = $scope.venue.branding ? {
    primaryColor: $scope.venue.branding.primaryColor ? colorService.rgbToHex($scope.venue.branding.primaryColor.red, $scope.venue.branding.primaryColor.green, $scope.venue.branding.primaryColor.blue) : '#000' //eslint-disable-line
  } : {};
  $scope.perkTypes = [{
    key: 'Line Jumper',
    value: 'LINE_JUMPER'
  }, {
    key: 'Free Entry',
    value: 'FREE_ENTRY'
  }, {
    key: 'Drink Deal',
    value: 'DRINK_DEAL'
  }, {
    key: 'Bring A Friend',
    value: 'BRING_A_FRIEND'
  }, {
    key: 'Member Event',
    value: 'MEMBER_EVENT'
  }, {
    key: 'Line Jumper',
    value: 'LINE_JUMPER'
  }, {
    key: 'Table Specials',
    value: 'TABLE_SPECIALS'
  }];

  $scope.membershipLevels = [{
      value: 0,
      label: 'Regular Users'
    },
    {
      value: 50,
      label: 'Membership Users Only'
    }
  ];

  $scope.saveInventory = function (form, $event, options) {
    if (!form) throw new Error('form is required');
    if ($event) $event.preventDefault();

    options = options || {};

    const service = $scope.schedule ? scheduleService : inventoryService;

    $scope.submitted = true;

    if (!form.$valid) return Promise.reject(new Error('form is invalid'));

    $scope.saving = true;

    const data = _mapChangedFormValuesToApiData(form);
    data.maintainScheduleLink = options.maintainScheduleLink || false;

    if (_isEmpty(data)) return null;

    return ($scope.editMode && !$scope.schedule ? $scope.tiersConfig.save() : Promise.resolve())
      .then(() => {
        if ($scope.editMode && !$scope.inventory.changed && $scope.inventory.schedule) {
          return modalService.confirmationInventory({
            size: 'sm'
          });
        } else if ($scope.editMode && $scope.inventory.recurring && $scope.inventory.recurring.enable) {
          return modalService.confirmationInventory({
            size: 'sm'
          });
        }

        return null;
      })
      .then(result => {
        if (result && result.modalInstance) {
          result.modalInstance.close();
        }

        if (result && result.confirm.maintainLink) {
          data.maintainScheduleLink = true;
        }

        if ($scope.editMode && $scope.inventory.recurring && $scope.inventory.recurring.enable) {
          data.disableRecurring = !data.maintainScheduleLink;
        }

        return $scope.editMode ? service.updateById($scope.inventory.id, data) : service.create(data);
      })
      .then(result => {
        $scope.saving = false;

        _extend($scope.inventory, result);

        $scope.onAddedOrUpdated({
          created: !$scope.editMode,
          inventory: result
        });

        return result;
      })
      .catch(response => {
        $scope.saving = false;

        alertService.error(sdkUtils.getErrorFromResponse(response));

        throw response;
      });
  };

  // ----------------------- Fees ----------------------- //

  // Used by the fees directive
  $scope.feesConfig = {};

  // User by the tiers directive
  $scope.tiersConfig = {};

  function getDefaultFees() {
    if (($scope.type === 'TICKET' || $scope.type === 'COVER') && ($scope.venue.ticketFees && $scope.venue.ticketFees.length)) {
      const fees = $scope.venue.ticketFees.map(_clone);

      return fees.map(fee => {
        if (fee.type === 'PERCENT') {
          fee.amount = Number((fee.amount * 100).toFixed(2));
        }
        return fee;
      });
    }

    if (($scope.type === 'TABLE' || $scope.type === 'PACKAGE') && ($scope.venue.fees && $scope.venue.fees.length)) {
      const fees = $scope.venue.fees.map(_clone);

      return fees.map(fee => {
        if (fee.type === 'PERCENT') {
          fee.amount = Number((fee.amount * 100).toFixed(2));
        }
        return fee;
      });
    }

    return [];
  }

  function _watchFields() {
    const watchFieldsForTotal = [
      'inventoryForm.price',
      'inventoryForm.tax',
      'inventoryForm.tip',
      'inventoryForm.depositAmount',
      'inventoryForm.userPaysProcessing',
      'inventoryForm.paymentType'
    ];

    angular.forEach(watchFieldsForTotal, (field) => {
      $scope.$watch(field, (newValue, oldValue) => {
        if (newValue !== oldValue) {
          _calculateTotalAndFees();
        }
      });
    });

    $scope.$watch('inventoryForm.fees', () => {
      $scope.allowReset = !_formFeesEqualVenueFees();

      _calculateTotalAndFees();
    }, true);
  }

  // Check to see if all the fees are the same
  // between the venue and the inventory
  function _formFeesEqualVenueFees() {
    if (_isEmpty($scope.venue.fees)) return true;
    if (_isEmpty($scope.inventoryForm.fees)) return false;

    return _every($scope.inventoryForm.fees, function (venueFee) {
      const feeValue = {
        amount: venueFee.type === 'PERCENT' ? venueFee.amount / 100 : venueFee.amount,
        name: venueFee.name,
        taxable: venueFee.taxable,
        type: venueFee.type
      };

      return _findIndex($scope.venue.fees, feeValue) >= 0;
    });
  }

  function _calculateTotalAndFees() {
    const formValues = angular.copy($scope.inventoryForm);
    const inventoryData = mapperService.mapInventoryToApi(formValues);

    const buyerData = inventoryUtils.buyerTotal({
      inventoryType: inventoryData.type,
      price: inventoryData.price,
      taxPercent: inventoryData.tax,
      tipPercent: inventoryData.tip,
      ticketProcessingFee: $scope.venue.ticketProcessingFee,
      tableProcessingFee: $scope.venue.tableProcessingFee,
      fees: inventoryData.fees,
      depositAmount: inventoryData.depositAmount,
      paymentType: inventoryData.paymentType,
      userPaysProcessing: inventoryData.userPaysProcessing
    });

    $scope.buyerData = buyerData;
  }

  function getDefaultTax() {
    if (($scope.type === 'TICKET' || $scope.type === 'COVER') && _isNumber($scope.venue.ticketTax)) {
      return Number(($scope.venue.ticketTax * 100).toFixed(4));
    } else if (($scope.type === 'TABLE' || $scope.type === 'PACKAGE') && _isNumber($scope.venue.tax)) {
      return Number(($scope.venue.tax * 100).toFixed(4));
    }

    return null;
  }

  function getDefaultTip() {
    if (($scope.type === 'TABLE' || $scope.type === 'PACKAGE') && _isNumber($scope.venue.tip)) return Number(($scope.venue.tip * 100).toFixed(2));

    return null;
  }

  // function getDefaultTerms() {
  //   if (($scope.type === 'TABLE' || $scope.type === 'PACKAGE') && _isString($scope.venue.tableTerms)) {
  //     return $scope.venue.tableTerms;
  //   } else if (($scope.type === 'TICKET') && _isString($scope.venue.ticketTerms)) {
  //     return $scope.venue.ticketTerms;
  //   }
  //
  //   return null;
  // }

  function getCurrentDay() {
    const d = parseInt($scope.day, 10);
    if (_isNumber(d) && d >= 0 && d < 7) return d;
    return 1;
  }

  function _mapChangedFormValuesToApiData(form) {
    if (!form) return null;

    let formData;

    if (!$scope.editMode) {
      formData = angular.copy($scope.inventoryForm);

      if ($scope.type === 'ACTIVE') {
        const momentDate = moment.utc($scope.date, 'x');
        formData.date = dateUtilsService.toUTCTimestampWithoutTime(momentDate);
      }
    } else {
      formData = formHelpersService.getChangedFormValues(form);
    }

    // If any part of the selling start/end changes, ensure date and time are mapped
    if (formData.sellingStartDate || formData.sellingStartTime) {
      formData.sellingStartDate = $scope.inventoryForm.sellingStartDate;
      formData.sellingStartTime = $scope.inventoryForm.sellingStartTime;
    }

    if (formData.sellingEndDate || formData.sellingEndTime) {
      formData.sellingEndDate = $scope.inventoryForm.sellingEndDate;
      formData.sellingEndTime = $scope.inventoryForm.sellingEndTime;
    }

    formData.userPaysProcessing = $scope.inventoryForm.userPaysProcessing;

    if (_isBoolean(formData.reservationEnabled)) {
      formData.reservationEnabled = $scope.inventoryForm.reservationEnabled;
    }

    formData.paymentType = $scope.inventoryForm.paymentType;

    const inventoryData = mapperService.mapInventoryToApi(formData);

    if (!$scope.editMode) {
      inventoryData.venue = $scope.venue.id;
    }

    if ($scope.schedule) {
      inventoryData.day = $scope.day;
    }

    return inventoryData;
  }

  function _getLayoutSections() {
    return layoutSectionService.listByVenueId($scope.venue.id)
      .then(results => {
        $scope.layoutSections = results;
      });
  }

  function _getVenueAndInventory() {
    return venueService.readById($scope.venue.id, {
        fields: [
          'id',
          'name',
          'enable',
          'tax',
          'tip',
          'fees',
          'ticketProcessingFee',
          'ticketCommission',
          'tableProcessingFee',
          'tableCommission',
          'ticketTerms',
          'tableTerms',
          'isSellingApproved',
          'reservation',
          'languageCode',
          'currencyCode'
        ].join(',')
      })
      .then(venue => {
        $scope.venue = venue;
        return ($scope.inventory && $scope.inventory.id) ? $scope.inventory : {};
      })
      .then(result => {
        $scope.inventory = result;
        $scope.date = $scope.date;

        // Setup form with inventory or defaults
        if ($scope.editMode) {
          if ($scope.inventory.type !== 'TICKET') {
            if (!('tax' in $scope.inventory) && $scope.venue.tax) {
              $scope.inventory.tax = $scope.venue.tax;
            }
            if (!('tip' in $scope.inventory) && $scope.venue.tip) {
              $scope.inventory.tip = $scope.venue.tip;
            }
          }

          $scope.inventoryForm = mapperService.mapInventoryToUI($scope.inventory);
        } else {
          $scope.inventoryForm = getDefaultInventoryForm();
        }
      })
      .finally(() => {
        _calculateTotalAndFees();
        _watchFields();
        $scope.loading = false;
      });
  }

  function getDefaultInventoryForm() {
    const form = {
      venue: $scope.venue.id,
      day: getCurrentDay(),
      guests: 1,
      disabled: false,
      type: $scope.type,
      fees: getDefaultFees(),
      tax: getDefaultTax(),
      tip: getDefaultTip(),
      // termsAndConditions: getDefaultTerms(),
      userPaysProcessing: true,
      paymentType: 'ADVANCE',
      enableRecurring: false
    };

    if ($scope.type === 'COVER') {
      form.disabled = true;
    }

    const momentDate = moment.utc($scope.date, 'x');

    form.date = momentDate;
    form.sellingStartDate = moment.utc();
    form.sellingEndDate = $scope.date.clone().add(1, 'day');

    if ($scope.type === 'TABLE' || $scope.type === 'PACKAGE') {
      form.reservationEnabled = false;
    }

    return form;
  }

  $scope.termsAndConditionsOptions = {
    toolbar: [
      ['style', ['bold', 'ul']],
      ['insert', ['link', 'hr']]
    ],
    height: 140
  };
}

AddInventoryCtrl.$inject = [
  '$scope',
  '$q',
  '$timeout',
  'jsSdk.venue',
  'jsSdk.inventory',
  'jsSdk.utils',
  'jsSdk.schedule',
  'jsSdk.layoutSection',
  'mapperService',
  'dateUtilsService',
  'alertService',
  'formHelpersService',
  'sellingOptionsHelpersService',
  'colorService',
  'supportService',
  'modalService'
];

export default AddInventoryCtrl;



// WEBPACK FOOTER //
// ./src/directives/addInventory/controller.js